import React from 'react';
import '../../../assests/css/filtercard.scss';

export interface filterCardProps{
    children: React.ReactNode;
}

export default function FilterCard(props: filterCardProps) {

    return (
        <div className="filter-card-container">
            {props.children}
        </div>
    );

}